export default __webpack_public_path__ + "static/media/Racing.8689a57b.svg";